import { z } from 'zod';
import { assignmentSchema, issuanceFormSchema } from './issuance.js';
/**
 * GET /api/alerts — the commander's alerts screen (REQUIREMENTS §2.6):
 * overdue mission gear, open loss/damage reports, items in rotation, and
 * forms signed with a comment. Scoped to the caller's reach exactly as the
 * roster is; a soldier gets their own.
 */
export const alertsResponseSchema = z.object({
    overdue: z.array(assignmentSchema),
    reports: z.array(assignmentSchema),
    inRotation: z.array(assignmentSchema),
    signedWithComment: z.array(issuanceFormSchema),
    soldiers: z.array(z.object({ uid: z.string(), name: z.string(), unitName: z.string().nullable() })),
});
//# sourceMappingURL=alerts.js.map